/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import React, { Component } from "react";
import AuthService from "./authService";
import { connect } from "react-redux";
import actionTypes from "../store/actions";
import Loader from "../component/loader";
import BusApiCall from "../helper/axios.js";
import constants from "../helper/constants";
import store from "../store/store";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { withTranslation } from "react-i18next";
import Button from "../component/button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import jp, { value } from "jsonpath";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getAppDomain } from "../helper/getAppDomain";
import { withNavigation } from "../helper/withNavigation.js";

var absoluteDomain = getAppDomain() || "";
class LoginScreen extends Component {
  state = {
    loading: true,
    tenantList: [],
    tenant: "",
    render: false,
    partnerLogin: false,
    userData: {},
    tenantLoginScheme: "DOMAIN",
    selectedTenant: {},
    inputValue: "",
  };
  componentDidMount() {
    this.props.setCompDidMount();
    var partnerLogin = false;
    var partnerId = "";
    if (this.props.router.location.pathname.includes("/partner/")) {
      partnerLogin = true;
      partnerId = this.props.router.params.partnerId;
      if (partnerLogin && partnerId) {
        this.setState({});
      }
    }
    var tokenInfo = JSON.parse(localStorage.getItem("tokenInfo"));
    if (
      this.props.tenantInfo &&
      this.props.tenantInfo.clientId &&
      tokenInfo &&
      tokenInfo.access_token
    ) {
      if (partnerLogin && partnerId) {
        if (partnerId === this.props.tenantInfo.clientId) {
          this.props.router.navigate("/");
        } else {
          var tenantData = JSON.parse(localStorage.getItem("roles"));
          var userData = tenantData.data.loggedInUser;
          this.setState(
            {
              partnerLogin: true,
              loading: false,
              userData: userData,
            },
            () => {
              this.setState({
                render: true,
              });
            },
          );
        }
      } else {
        this.props.router.navigate("/");
      }
    } else {
      var Cookies = document.cookie.split(";");
      for (var i = 0; i < Cookies.length; i++) {
        document.cookie =
          Cookies[i].split("=")[0] +
          "=; path=/; domain=" +
          absoluteDomain +
          "; secure; expires=" +
          new Date(0).toUTCString();
      }
      localStorage.clear();
      sessionStorage.clear();
      // Get available tenants list
      BusApiCall("GET", `${constants.busV44Url}/tenant/auth`)
        .then((data) => {
          var tempRes = data.data;
          // var tempRes = [];
          // let search = new URLSearchParams(this.props.router.location.search);
          // let partnerId = search.get("partnerId");
          if (tempRes && tempRes.tenants && tempRes.tenants.length > 0) {
            if (tempRes.tenants.length === 1) {
              this.props.setOauthAuthority(tempRes.tenants[0]);
              var url = window.location.origin;
              window.location.href = url;
            } else if (partnerLogin && partnerId) {
              var index = tempRes.tenants.findIndex(
                (x) => x.tenantId === partnerId,
              );
              if (index > -1) {
                this.props.setOauthAuthority(tempRes.tenants[index]);
                var url = window.location.origin;
                window.location.href = url;
              } else {
                var sortedTenantsList = tempRes.tenants.sort(function (a, b) {
                  if (a.tenantName.toLowerCase() < b.tenantName.toLowerCase()) {
                    return -1;
                  }
                  if (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) {
                    return 1;
                  }
                  return 0;
                });
                this.setState(
                  {
                    tenantList: sortedTenantsList,
                  },
                  () => {
                    this.setState({
                      tenant: data.data.tenants[0].tenantId,
                      selectedTenant: data.data.tenants[0],
                      inputValue: data.data.tenants[0].tenantName,
                      loading: false,
                      render: true,
                    });
                  },
                );
              }
            } else {
              if (this.state.tenantLoginScheme === "DOMAIN") {
                for (var i = 0; i < tempRes.tenants.length; i++) {
                  if (
                    tempRes.tenants[i].domain &&
                    tempRes.tenants[i].domain === window.location.hostname &&
                    tempRes.tenants[i].tenantProviderType ===
                      "SALES_CHNL_PROVIDER"
                  ) {
                    this.props.setOauthAuthority(tempRes.tenants[i]);
                    var url = window.location.origin;
                    window.location.href = url;
                    return;
                  }
                  if (tempRes.tenants.length === i + 1) {
                    var domainTenants = jp.query(
                      tempRes.tenants,
                      '$[?(@.domain=="' + window.location.hostname + '")]',
                    );
                    if (domainTenants.length === 1) {
                      this.props.setOauthAuthority(domainTenants[0]);
                      var url = window.location.origin;
                      window.location.href = url;
                      return;
                    } else {
                      var sortedTenantsList = tempRes.tenants.sort(
                        function (a, b) {
                          if (
                            a.tenantName.toLowerCase() <
                            b.tenantName.toLowerCase()
                          ) {
                            return -1;
                          }
                          if (
                            a.tenantName.toLowerCase() >
                            b.tenantName.toLowerCase()
                          ) {
                            return 1;
                          }
                          return 0;
                        },
                      );
                      this.setState(
                        {
                          tenantList: sortedTenantsList,
                        },
                        () => {
                          this.setState({
                            tenant: data.data.tenants[0].tenantId,
                            selectedTenant: data.data.tenants[0],
                            inputValue: data.data.tenants[0].tenantName,
                            loading: false,
                            render: true,
                          });
                        },
                      );
                    }
                  }
                }
              } else {
                var sortedTenantsList = tempRes.tenants.sort(function (a, b) {
                  if (a.tenantName.toLowerCase() < b.tenantName.toLowerCase()) {
                    return -1;
                  }
                  if (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) {
                    return 1;
                  }
                  return 0;
                });
                this.setState(
                  {
                    tenantList: sortedTenantsList,
                  },
                  () => {
                    this.setState({
                      tenant: data.data.tenants[0].tenantId,
                      selectedTenant: data.data.tenants[0],
                      inputValue: data.data.tenants[0].tenantName,
                      loading: false,
                      render: true,
                    });
                  },
                );
              }
            }
          } else {
            this.props.setErrorMessage(
              this.props.t("NO_TENANT_CONFIGURED"),
              false,
            );
            // this.props.setOauthAuthority(defaultTenantData);
            // var url = window.location.origin;
            // window.location.href = url;
          }
        })
        .catch((err) => {
          this.props.setErrorMessage(
            this.props.t("NO_TENANT_CONFIGURED"),
            false,
          );
          // this.props.setOauthAuthority(defaultTenantData);
          // var url = window.location.origin;
          // window.location.href = url;
        });
    }
  }
  onChange = (e) => {
    this.setState({
      tenant: e.target.value,
    });
  };
  // Set tenant in store and redirect to Keycloak realm for login
  submitTenant = () => {
    // var index = this.state.tenantList.findIndex((x) => x.tenantId === this.state.tenant);
    // if (index > -1) {
    //     var data = this.state.tenantList[index];
    //     this.props.setOauthAuthority(data);
    //     var url = window.location.origin;
    //     window.location.href = url;
    // }
    if (this.state.selectedTenant && this.state.selectedTenant.tenantId) {
      this.props.setOauthAuthority(this.state.selectedTenant);
      var url = window.location.origin;
      window.location.href = url;
    } else {
      this.props.setErrorMessage(this.props.t("NO_TENANT_SELECTED"), false);
    }
  };
  confirmTenant = (val) => {
    if (val) {
      var Cookies = document.cookie.split(";");
      for (var i = 0; i < Cookies.length; i++) {
        if (
          window.location.protocol === "https:" ||
          window.location.protocol === "HTTPS:"
        ) {
          document.cookie =
            Cookies[i].split("=")[0] +
            "=; path=/; domain=" +
            absoluteDomain +
            "; secure; expires=" +
            new Date(0).toUTCString();
        } else {
          document.cookie =
            Cookies[i].split("=")[0] +
            "=; path=/; domain=" +
            absoluteDomain +
            "; expires=" +
            new Date(0).toUTCString();
        }
      }
      sessionStorage.clear();
      localStorage.clear();
      window.location.reload();
    } else {
      this.props.router.navigate("/");
    }
  };
  setInputValue = (val) => {
    this.setState({
      inputValue: val,
    });
  };
  setValue = (val) => {
    this.setState({
      selectedTenant: val,
    });
  };
  render() {
    const { t } = this.props;
    return (
      <div>
        {!this.state.partnerLogin && this.state.render && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"sm"}
            fullWidth={true}
            open={true}
            aria-labelledby="delete-dialog-title"
          >
            <DialogTitle id="delete-dialog-title">
              {t("SELECT_TENANT")}
            </DialogTitle>
            <DialogContent dividers>
              {/* <FormControl variant="outlined" size={'small'}>
                                <Select
                                    value={this.state.tenant}
                                    native
                                    labelId="tenantLabel"
                                    onChange={event => this.onChange(event)}
                                    inputProps={{
                                        name: 'tenant',
                                    }}
                                >
                                    <option value={''} disabled>{t('SELECT_TENANT')}</option>
                                    {this.state.tenantList.map((item, index) =>
                                        <option value={item.tenantId} key={index}>{item.tenantName}</option>
                                    )}
                                </Select>
                            </FormControl>
                            <br /><br /> */}
              {this.state.tenantList && this.state.tenantList.length > 0 && (
                <Autocomplete
                  id="tenant-list-autocomplete"
                  options={this.state.tenantList}
                  getOptionLabel={(option) => option.tenantName}
                  style={{}}
                  // value={this.state.tenant}
                  onChange={(event, newValue) => {
                    this.setValue(newValue);
                  }}
                  className="tenant-list-autocomplete"
                  value={this.state.selectedTenant}
                  inputValue={this.state.inputValue}
                  onInputChange={(event, newInputValue) => {
                    this.setInputValue(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.submitTenant()}
                style={{
                  backgroundColor: "#1976d2",
                  borderColor: "#1976d2",
                  color: "#fff",
                }}
              >
                {t("SUBMIT")}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.partnerLogin && this.state.render && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"sm"}
            fullWidth={true}
            open={true}
            aria-labelledby="delete-dialog-title"
          >
            <DialogTitle id="delete-dialog-title">{t("CONFIRM")}</DialogTitle>
            <DialogContent dividers>
              {t("ALREADY_LOGGED_IN_MESSAGE")} {this.state.userData.userName}.{" "}
              {t("DO_YOU_WANT_TO_LOGOUT")}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.confirmTenant(false)}
                style={{
                  backgroundColor: "#1976d2",
                  borderColor: "#1976d2",
                  color: "#fff",
                }}
              >
                {t("NO")}
              </Button>
              <Button
                onClick={() => this.confirmTenant(true)}
                style={{
                  backgroundColor: "#1976d2",
                  borderColor: "#1976d2",
                  color: "#fff",
                }}
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
    publicBrowsing: state.auth.publicBrowsing,
    tenantInfo: state.auth.tenantInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (profile) =>
      dispatch({ type: actionTypes.AUTHENTICATE, profile }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setTenantId: (id) => dispatch({ type: actionTypes.SET_TENANT_ID, id }),
    setTenantData: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_DATA, data }),
    setTenantLocale: (locale) =>
      dispatch({ type: actionTypes.SET_TENANT_LOCALE, locale }),
    setPublicBrowsing: (data) =>
      dispatch({ type: actionTypes.SET_PUBLIC_BROWSING, data }),
    setEcommerceCustData: (data) =>
      dispatch({ type: actionTypes.ECOMMERCE_CUST_DATA, data }),
    setOauthAuthority: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_INFO, data }),
    setErrorMessage: (errMsg) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(LoginScreen)));
